import { Duration } from '@/utils/types/global';
import getLocalTime from '@/utils/time/localtime';

/**
 * init or generate durationRow Obj and save localStorage.
 */
const getDurationUtc = (): Duration => {
  const durationRow = {
    start: getLocalTime(0, new Date(new Date().getTime() - 86400000)),
    end: getLocalTime(0, new Date()),
    step: 'HOUR'
  };
  return durationRow;
};

export default getDurationUtc;
